import {useEffect, useRef} from 'react'

export const useTruncatedTooltip = (text: string) => {
  const ref = useRef<HTMLDivElement>(null)

  useEffect(() => {
    if (ref?.current) {
      const isTextTruncated =
        ref.current.scrollHeight > ref.current.clientHeight

      ref.current.title = isTextTruncated ? text : ''
    }
  }, [text])

  return ref
}
